import React from "react";
import NewProfileButton from "../components/NewProfileButton";
import ScoreDisplay from "../components/ScoreDisplay";
import Slider from "react-slick";

const ReportsPage = (props) => {
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
  };

  function ShowReports() {
    if (props.activeProfile.History) {
      return (
        <div className="ScoreContainer ">
          <span className="scoreSlider">
            <Slider {...settings}>
              {Object.keys(props.activeProfile.History).map((item) => {
                var His = props.activeProfile.History;
                var total = His[item].Scores.Total;
                var timeStamp = item;
                var paid = His[item].paid;
                return (
                  <ScoreDisplay
                    Dev={props.Dev}
                    Score={total}
                    key={item}
                    scoreDate={timeStamp}
                    Subscribed={props.Subscribed}
                    paid={paid}></ScoreDisplay>
                );
              })}
            </Slider>
          </span>
          <br />
          <br />
        </div>
      );
    } else {
      return <p> You have no past reports.</p>;
    }
  }

  return (
    <div>
      {props.Dev ? <h1> Reports page </h1> : <></>}
      <h2>View Past Reports</h2>
      <p>Click on the report you wish to see for expanded view.</p>
      {ShowReports()}
    </div>
  );
};

export default ReportsPage;
